import { render } from "./ContactLayout.vue?vue&type=template&id=68d43766"
import script from "./ContactLayout.vue?vue&type=script&lang=js"
export * from "./ContactLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__